import {
  IconIndustries,
  IconJobs,
  IconSkills,
  IconLocationPin,
  IconTopicChannels,
  IconSalary,
  IconHome,
  IconPartTime,
} from '@xingternal/icons';

export const variantB = {
  options: [
    {
      preference: 'preferred_locations',
      header: 'LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG',
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN',
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH',
      ],
    },
    {
      preference: 'career_level',
      header: 'LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY',
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL',
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER',
      ],
    },
    {
      preference: 'salary_expectations',
      header: 'LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY',
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY',
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY',
      ],
    },
  ],
  disabled: {
    header: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE',
    items: [
      {
        icon: IconJobs,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE',
        id: 'ideal_positions',
      },
      {
        icon: IconSkills,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES',
        id: 'preferred_discipline',
      },
      {
        icon: IconIndustries,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES',
        id: 'preferred_industry',
      },
    ],
    more: 3,
  },
};

export const variantC = {
  options: [
    {
      preference: 'preferred_locations',
      icon: IconLocationPin,
      header: 'LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE',
      copy: 'LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG',
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN',
        'LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH',
      ],
      showMore: 'LOSP_PREFERENCES_EXPERIMENT_SEE_MORE',
    },
    {
      preference: 'career_level',
      icon: IconTopicChannels,
      copy: 'LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON',
      header: 'LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY',
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL',
        'LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER',
      ],
      showMore: 'LOSP_PREFERENCES_EXPERIMENT_SEE_MORE',
    },
    {
      preference: 'salary_expectations',
      icon: IconSalary,
      copy: 'LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON',
      header: 'LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY',
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY',
        'LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY',
      ],
      showMore: 'LOSP_PREFERENCES_EXPERIMENT_SEE_MORE',
    },
    {
      preference: 'homeoffice',
      icon: IconHome,
      copy: 'LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON',
      header: 'LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE',
      values: [
        'LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE',
        'LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE',
      ],
      showMore: 'LOSP_PREFERENCES_EXPERIMENT_SEE_MORE',
    },
  ],
  disabled: {
    items: [
      {
        icon: IconJobs,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE',
        id: 'ideal_positions',
      },
      {
        icon: IconPartTime,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS',
        id: 'working_hours',
      },
      {
        icon: IconSkills,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES',
        id: 'preferred_discipline',
      },
      {
        icon: IconIndustries,
        copy: 'LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES',
        id: 'preferred_industry',
      },
    ],
  },
};
